module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-6.d59e4fef.jpg";